module.exports = __webpack_public_path__ + "static/media/wood.55721cc9.jpg";